import { PartialMessage } from '@bufbuild/protobuf'
import { Site } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/site_pb'
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google'
import { Suspense } from 'react'

import { ClickRank } from './click-rank'
import { FacebookPixel } from './facebook-pixel'
import { GoogleAnalyticsTracker } from './google-analytics-tracker'

type Props = {
  site: PartialMessage<Site> | undefined
}

export const PageMeta = ({ site }: Props) => {
  return (
    <>
      <GoogleAnalytics gaId="G-NPK4CJ6F6N" />

      {site?.googleAnalyticsTrackingId && (
        <>
          <GoogleAnalytics gaId={site.googleAnalyticsTrackingId} />
          <GoogleAnalyticsTracker gaId={site.googleAnalyticsTrackingId} />
        </>
      )}

      {site?.googleTagManagerId && (
        <GoogleTagManager gtmId={site.googleTagManagerId} />
      )}

      {site?.facebookPixelId && (
        <Suspense fallback={null}>
          <FacebookPixel pixelId={site.facebookPixelId} />
        </Suspense>
      )}

      {site?.customHtmlBodyEnd && (
        <div dangerouslySetInnerHTML={{ __html: site.customHtmlBodyEnd }} />
      )}

      {site?.slug === 'round-10-boxing-club' && (
        <ClickRank id="25290467-7c25-499c-8f8f-84c0d4e4167f" />
      )}
    </>
  )
}
